import { logOut } from '@nusrif/utils';
import config from '@nusrif/config';

export type ApiRequestOptions = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  headers?: Record<string, string>;
  body?: any;
  params?: Record<string, string | number | boolean>;
  signal?: AbortSignal;
};

export async function apiRequest<T = any>(
  endpoint: string,
  options: ApiRequestOptions = {}
): Promise<T> {
  const { method = 'GET', headers = {}, body, params, signal } = options;
  let url = config.api.baseUrl + endpoint;

  // Handle query params
  if (params && Object.keys(params).length > 0) {
    const query = new URLSearchParams(params as Record<string, string>).toString();
    url += (url.includes('?') ? '&' : '?') + query;
  }

  // Get token from localStorage if available
  const authHeaders = { ...headers };
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('token');
    if (token) {
      authHeaders['Authorization'] = `Bearer ${token}`;
    }
  }

  const fetchOptions: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
    },
    signal,
  };

  if (body !== undefined && method !== 'GET') {
    fetchOptions.body = JSON.stringify(body);
  }

  // Timeout handling
  const timeout = 30000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  if (!signal) fetchOptions.signal = controller.signal;

  try {
    const response = await fetch(url, fetchOptions);
    clearTimeout(timeoutId);
    if (!response.ok) {
      if(response.status === 401) {
        // Logout the user
        logOut();
      }

      const errorData = await response.json().catch(() => ({}));
      throw { status: response.status, message: response.statusText, ...errorData };
    }
    // If response is empty, return null
    if (response.status === 204) return null as T;
    return (await response.json()) as T;
  } catch (error: any) {

    console.log('error', error)
    if (error.name === 'AbortError') {
      throw { status: 408, message: 'Request timeout' };
    }
    throw error;
  }
} 